import { h } from 'preact';
import { ProductCardSkeleton } from './ProductCardSkeleton';
import styles from '../product/ProductGrid.module.scss';
export function ProductGridSkeleton({ count = 9, layout }) {
    // Determine the grid class based on card layout
    let layoutClass = '';
    switch (layout.cardLayout) {
        case 'gridTwo':
            layoutClass = styles.productGridTwo;
            break;
        case 'gridThree':
            layoutClass = styles.productGridThree;
            break;
        case 'gridFour':
            layoutClass = styles.productGridFour;
            break;
        case 'list':
            layoutClass = styles.productList;
            break;
        default:
            layoutClass = styles.productGridThree;
    }
    // Apply filter layout adjustments only for grid layouts with side filter
    const needsFilterAdjustment = layout.filterLayout === 'filterSide' &&
        (layout.cardLayout === 'gridFour' || layout.cardLayout === 'gridThree' || layout.cardLayout === 'gridTwo');
    const finalClassName = needsFilterAdjustment
        ? `${layoutClass} ${styles.productGridFourWithSideFilter}`
        : layoutClass;
    return (h("div", { class: finalClassName, "data-layout": layout.cardLayout, "data-filter-layout": layout.filterLayout }, Array.from({ length: count }).map((_, index) => (h(ProductCardSkeleton, { key: index, layout: layout.cardLayout })))));
}
